import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const createVmTemplateDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createVmTemplateRegion',
        popover: {
          title: 'VM Name',
          description:
            'This field displays the name of the virtual machine. You can edit the name to better identify and organize your VMs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateName',
        popover: {
          title: 'VM Region',
          description:
            'This indicates the geographic region where the VM is hosted. This can impact performance and compliance, so choose the region carefully.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateDisk',
        popover: {
          title: 'VM Cluster',
          description:
            'This section shows the cluster to which the VM belongs. Clusters are groups of VMs that work together to ensure high availability and load balancing.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateOneTemplateId',
        popover: {
          title: 'VM Operating System',
          description:
            'Here you can view and configure the operating system of the virtual machine. The OS determines the VM’s capabilities and compatibility.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.createVmTemplateDescription',
        popover: {
          title: 'Private Network Configuration',
          description:
            'This table displays the network settings and connections for the VM. Ensure the VM is correctly configured to communicate within the network.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default createVmTemplateDriverObj;
